import * as React from 'react';
import ModalX from '../../BaseComponents/ModalX';
import BookingPreview from '../../BookingPreview';
import { OrderStatus } from '@websky/graphql';
import { useTranslation } from 'react-i18next';
import { sessionStorageGet, sessionStorageSet } from '../../cache';
import { getSaveOrderToAccountShownKey } from '../utils';
import { StepsEnum } from '../../types';
import { useConfig } from '../../context';
const AnonymousOrderModal = ({ order, currentUser, userLoading, currentStepType, refetchUser }) => {
    const { t } = useTranslation('AnonymousOrderModal');
    const { global: { showBookingPreview } } = useConfig();
    /** WEBSKY-6759: Логика прикрепления анонимных заказов  */
    const saveOrderToAccountShownKey = getSaveOrderToAccountShownKey(order.id);
    const saveOrderToAccountShown = sessionStorageGet(saveOrderToAccountShownKey, false);
    const [openBookingPreviewModal, setOpenBookingPreviewModal] = React.useState(false);
    React.useEffect(() => {
        var _a;
        /**
         * Показываем только на странице /order
         * Если пользователь не авторизован или нет заказа ничего не выводим
         */
        if (currentStepType !== StepsEnum.Order ||
            order.status === OrderStatus.New ||
            !order.locator ||
            !currentUser ||
            userLoading ||
            !showBookingPreview) {
            return;
        }
        /**
         * В массиве ordersListPaginated.edges лежат заказы, сохраненные в личном кабинете.
         * Эти заказы отфильтрованы по order.locator в запросе useGetAccountInfoQuery
         */
        const savedOrders = ((_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.ordersListPaginated) === null || _a === void 0 ? void 0 : _a.edges) || [];
        const savedOrderLocatorSet = new Set(savedOrders.map(order => order === null || order === void 0 ? void 0 : order.node.locator));
        /** Выводим если текущего заказа нет в личном кабинете и модалку еще не показывали */
        if (!savedOrderLocatorSet.has(order.locator) && !saveOrderToAccountShown) {
            setOpenBookingPreviewModal(true);
        }
        else {
            setOpenBookingPreviewModal(false);
        }
    }, [order, currentUser, currentStepType, userLoading, saveOrderToAccountShown]);
    const handleCloseBookingPreviewModal = () => {
        setOpenBookingPreviewModal(false);
        sessionStorageSet(saveOrderToAccountShownKey, true);
    };
    const handleViewOrderClick = () => {
        setOpenBookingPreviewModal(false);
        refetchUser();
    };
    return (React.createElement(ModalX, { isOpen: openBookingPreviewModal, onClose: handleCloseBookingPreviewModal },
        React.createElement(BookingPreview, { order: order, redirectViaHistory: true, onViewOrderClick: handleViewOrderClick, title: t('Would you like to add this booking to your cabinet?') })));
};
export default AnonymousOrderModal;
